import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vittaa-icons',
  templateUrl: './vittaa-icons.component.html',
  styleUrls: ['./vittaa-icons.component.scss']
})
export class VittaaIconsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
